import React, {Component} from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import {IntlProvider} from 'react-intl';
import {FormattedNumber} from "react-intl";
import {Container, Dropdown, Form, Header, Icon, Message, Segment, Table} from 'semantic-ui-react';
import Loading from "../extras/Loading";
import update from 'react-addons-update';
import expenseDetailData from "../../data/ExpenseDetailData";
import SweetAlert from 'sweetalert-react';
import ExpenseRow from "./ExpenseRow";
import {connect} from "react-redux";
import {expenseDetailAdd, listExpensesDetail} from "../../actions/ExpenseDetailActions";
import NoData from "../extras/NoData";
import {showToast} from "../../actions/ToastAction";
import 'sweetalert/dist/sweetalert.css';

const QuestionContent = (props) => <Container>
    <p>¿Desea actualizar el precio de compra?</p>
    <Table singleLine>
        <Table.Body>
            <Table.Row negative>
                <Table.Cell><strong>{props.name}</strong></Table.Cell>
                <Table.Cell textAlign='right'>
                    $<FormattedNumber
                        value={props.last_price}
                        currency="USD"
                        maximumFractionDigits={0}
                        minimumFractionDigits={0}
                    />
                </Table.Cell>
                <Table.Cell width={1}>
                    <Icon name='chevron right' />
                </Table.Cell>
                <Table.Cell textAlign='left'>
                    <strong>$
                        <FormattedNumber
                            value={props.price}
                            currency="USD"
                            maximumFractionDigits={0}
                            minimumFractionDigits={0}
                        />
                    </strong>
                </Table.Cell>
            </Table.Row>
        </Table.Body>
    </Table>
</Container>;

class ExpenseDetail extends Component {
    constructor(props){
        super(props);
        let options = props.products_ingredients.map(option =>{
            return {
                key:option.id,
                value:option.id,
                text: `${option.name} - ${option.unit}`
            };
        });

        this.state = {
            id:props.id,
            loading: true,
            options,
            data:{
                product_ingredient:null,
                quantity: '',
                price: '',
                is_product: false,
                expense: this.props.id,
                last_price: 0,
                name: ''
            },
            product_ingredient_error: false,
            quantity_error: false,
            price_error: false,
            alert_question: false,
            message_alert: null,
            sending: false,
            products_ingredients: props.products_ingredients
        };
    };

    componentDidMount() {
        if(this.props.id){
            this.setState({id:this.props.id});
            this.getData(this.props.id);
        }
    }

    componentWillReceiveProps(nextProps){
        if(this.state.id === null && nextProps.id !== null){
            this.getData(nextProps.id);
            this.setState({id:nextProps.id});
        }
    }

    getData = (id) =>{
        expenseDetailData.list(id).then(result =>{
            this.props.listExpensesDetail(result);
            this.setState({loading:false});
        });
    };

    handleChange = (e, { name, value }) => {
        if(name==='product_ingredient'){
            let product = this.state.products_ingredients.find(data => data.id === value);
            let data = update(this.state, {
                data: {
                    [name]: {
                        $set: value
                    },
                    is_product: {$set: product.is_product},
                    last_price: {$set: product.price},
                    name: {$set: `${product.name} - ${product.is_product ? 'Unid.':product.unit}`}
                }
            });
            this.setState(data);
        }else{
            let data = update(this.state, {
                data: {
                    [name]: {
                        $set: value
                    }
                }
            });
            this.setState(data);
        }
        this.resetErrors();
    };

    confirmData = () =>{
        this.resetErrors();
        if(this.state.data.product_ingredient === null){
            this.setState({product_ingredient_error:true})
        }else if(this.state.data.quantity <= 0){
            this.setState({quantity_error:true})
        }else if(this.state.data.price <= 0){
            this.setState({price_error:true})
        }else{
            let message_alert = renderToStaticMarkup(<IntlProvider locale={navigator.language}><QuestionContent {...this.state.data}/></IntlProvider>);
            this.setState({alert_question:true, message_alert});
        }
    };

    addDetail = () => {
        this.setState({ alert_question: false, sending:true });
        let detail = Object.assign({}, this.state.data);
        detail.product = detail.is_product ? detail.product_ingredient:null;
        detail.ingredient = !detail.is_product ? detail.product_ingredient:null;
        detail.expense = this.state.id;
        delete detail.is_product;
        delete detail.product_ingredient;
        expenseDetailData.add(detail, (res) => {
            if(res.save){
                let products_ingredients = this.state.products_ingredients.map((product_ingredient)=> {
                    if((res.data.product !== null && product_ingredient.id === res.data.product.id) ||
                        (res.data.ingredient !== null && product_ingredient.id === res.data.ingredient.id)){
                        product_ingredient.price = detail.price;
                        return product_ingredient;
                    }else{
                        return product_ingredient;
                    }
                });

                this.setState({products_ingredients});
                this.props.expenseDetailAdd(res.data);
                this.props.showToast({type:'success', message:'Detalle agregado!'});

                let options = products_ingredients.map(option =>{
                    return {
                        key:option.id,
                        value:option.id,
                        text: `${option.name} - ${option.unit}`
                    };
                });

                this.setState({
                    data:{
                        product_ingredient:null,
                        quantity: '',
                        price: '',
                        is_product: false,
                        expense: this.props.id
                    },
                    sending:false,
                    options
                });
            }else{
                this.setState({sending:false});
                this.props.showToast({type:'error', message:'Tenemos un problema!'});
            }
        }).catch(() => {
            this.setState({sending:false});
            this.props.showToast({type: 'error', message: 'Tenemos un problema!'})
        })
    };

    resetErrors = () => {
      this.setState({
          product_ingredient_error:false,
          quantity_error:false,
          price_error:false
      });
    };

    showData = () =>{
        if(this.state.loading){
            return(<Loading/>)
        }
        return (
            <Container>
                <Header as='h2' attached='top'>Detalle</Header>
                <Segment secondary attached>
                    <Form.Group>
                        <Dropdown
                            value={this.state.data.product_ingredient}
                            onChange={this.handleChange}
                            options={this.state.options}
                            placeholder='Producto o Ingrediente'
                            search
                            name='product_ingredient'
                            selection
                            error={this.state.product_ingredient_error}
                        />
                        <Form.Input
                            placeholder='Cant.'
                            width={3}
                            min={1}
                            type='number'
                            name='quantity'
                            value={this.state.data.quantity}
                            onChange={this.handleChange}
                            error={this.state.quantity_error}
                        />
                        <Form.Input
                            placeholder='Valor Unitario'
                            width={5}
                            min={1}
                            type='number'
                            name='price'
                            value={this.state.data.price}
                            onChange={this.handleChange}
                            error={this.state.price_error}
                        />
                        <Form.Button icon='add' onClick={this.confirmData} loading={this.state.sending} disabled={this.state.sending}/>
                    </Form.Group>
                </Segment>
                <Segment attached>
                    <Table singleLine>
                        <Table.Body>
                            {this.props.expense_detail.length > 0 ? this.props.expense_detail.map(detail => {
                                return (<ExpenseRow {...detail} key={detail.id}/>);
                            }):<NoData colSpan={4}/>}
                        </Table.Body>
                    </Table>
                </Segment>
                <SweetAlert
                    show={this.state.alert_question}
                    title="Actualizar Costos"
                    showCancelButton
                    html
                    text={this.state.message_alert}
                    confirmButtonText="Aceptar"
                    cancelButtonText="Cancelar"
                    confirmButtonColor='#00D1C0'
                    onConfirm={() => {
                        this.addDetail();
                    }}
                    onCancel={() => {
                        this.setState({ alert_question: false });
                    }}
                />
            </Container>
        )
    };

    render() {
        return (
            <Container>
                {this.props.id ? this.showData():<Message
                    icon='bell'
                    header='Para agregar detalles de este gasto, primero debe GUARDAR.'
                />}
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {
        expense_detail: state.get('expense_detail'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        listExpensesDetail(data) {
            dispatch(listExpensesDetail(data))
        },
        showToast(toast){
            dispatch(showToast(toast))
        },
        expenseDetailAdd(expense_detail){
            dispatch(expenseDetailAdd(expense_detail))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExpenseDetail)



// WEBPACK FOOTER //
// ./src/components/expenses/ExpenseDetail.js